import React, { createContext, Fragment, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, BrowserRouter, useLocation } from 'react-router-dom';
// import Navbar from './Components/Navbar';
import Sidebar from '../Components/Sidebar';  
import HomeComponent from '../Components/Home/HomeComponent'; 
import Footer from '../Components/Footer'; 
import NotFoundPage from '../Components/NotFoundPage'; 
import AdminRoutes from '../Routes/AdminRoutes'; 
import AuthRoutes from '../Routes/AuthRoutes';
import { ProtectedComponent } from '../Pages/Authentication';
import DonorRoutes from '../Routes/DonorRoutes';
import RequestorRoutes from '../Routes/RquestorRoutes';
import ProfileManagementRoutes from '../Routes/ProfileManagementRoutes';
import { GlobalInfo } from '../Contexts/GlobalContext';
import {FilterInfo } from '../Contexts/FilterContext';
import TokenService from "../Services/Token.service";
import DashboardHeader from '../Components/Dashboard/DashboardHeader';
import SessionTimeout from '../Pages/Authentication/SessionTimeout';
import { AdminService } from '../Services/Admin.service';
import PoliciesRoute from './PoliciesRoutes';
import Help from '../Pages/FAQ/Help';
import PaymentRoutes from './PaymentRoutes';
 


function RouteWatcher({ setAdminManagementState }) {
  const location = useLocation();

  useEffect(() => {
    // if (location.pathname !== "/admin/administrative-settings/admin-management/admin-profile") {
    if (!location.pathname.includes("admin-profile") && !location.pathname.includes("requestor-profile")) {
      setAdminManagementState({ page: 1, limit: 10, offset: 0 });
    }
  }, [location.pathname]);

  return null; // This component doesn't render anything
}
function AppRoutes({isLoggedIn,setIsLoggedIn}) {
    const [theme, setTheme] = useState('grey')
    // const [isLoggedIn, setIsLoggedIn] = useState(!!TokenService.getUser()); 
    const [userDetails, setUserDetails] = useState(null);
    const [isSidebarVisible, setSidebarVisible] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const baseUrl = process.env.REACT_APP_BASE_URL || "";

    const toggleSidebar = () => {
      setSidebarVisible((prevVisible) => !prevVisible); 
    };
      
    useEffect(() => {
        // Function to update window width and trigger re-render
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // event listener for window resize
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        // Refresh the sidebar component based on `windowWidth` for expand/collapse 
        if (windowWidth <= 480 ||windowWidth <= 992  ) {
          setSidebarVisible(false);  // Collapse sidebar on small screens
        }
        else{   // large screen then show side bar
          setSidebarVisible(true); 
        }
    }, [windowWidth]);

    useEffect(() => {
      if (isLoggedIn &&( window.innerWidth <= 480 || window.innerWidth <= 992)) {
        setSidebarVisible(false); // Ensuring sidebar is collapsed on smaller devices
      }
    }, [isLoggedIn]);

    const updateUserDetails = (data) => {
      setUserDetails(data);
      setIsLoggedIn(!!data);   

      if(typeof data !== 'undefined' && data !== null) {

        const { user, roles } = data;
        const { active, is_requestor_status, is_donor_status } = user;

        if (!roles.includes("Superadmin")) {
          const permissions = [];
    
          if (!active) {
            permissions.push("request-new-sample", "job-board");
          } else {
            if (roles.includes("Admin")) {
              if (is_requestor_status.toString() !== "1") permissions.push("request-new-sample");
              if (is_donor_status.toString() !== "1") permissions.push("job-board");
            } else {
              if (roles.includes("Requestor") && is_requestor_status.toString() !== "1") {
                permissions.push("request-new-sample");
              }
              if (roles.includes("Donor") && is_donor_status.toString() !== "1") {
                permissions.push("job-board");
              }
            }
          }    
          TokenService.setUserRestrictions(permissions);  
      } else {
        const permissions = [];
        if (is_requestor_status.toString() !== "1") permissions.push("request-new-sample");
        if (is_donor_status.toString() !== "1") permissions.push("job-board");
        TokenService.setUserRestrictions(permissions);
      }       

    }
      
  };

  function GetData(data){ 
    alert('Hello from app component '+data);
    setTheme(data);
  }

  const [adminManagementState, setAdminManagementState] = useState({ page: 1, limit: 10, offset: 0 });

  useEffect(()=>{
    console.log("adminManagementState",adminManagementState);
  },[adminManagementState]);
  const [isRestrictedPage, setIsRestrictedPage] = useState(false);

return( 
    <> 
      <GlobalInfo.Provider value={{appUserIsLogin: isLoggedIn ,theme :theme, GetData : GetData, toggleSidebar, isSidebarVisible:isSidebarVisible , userDetails:userDetails,  updateUserDetails: updateUserDetails,  isRestrictedPage, setIsRestrictedPage,  setIsLoggedIn: setIsLoggedIn}}>
        <FilterInfo.Provider value={{adminManagementState,setAdminManagementState }}>
            {/* <BrowserRouter basename={baseUrl}> */}

                {!isRestrictedPage && isLoggedIn && 
                  <Sidebar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn}  isSidebarVisible={isSidebarVisible} toggleSidebar={toggleSidebar}/>  
                }
  
                {!isRestrictedPage && isLoggedIn &&(<DashboardHeader/>)}
                
                <RouteWatcher setAdminManagementState={setAdminManagementState} />
                <Routes>
                  <Route path="/" element={<ProtectedComponent Component={HomeComponent }/>} />
                  <Route path="admin/*" element={<ProtectedComponent Component={AdminRoutes} requiredRole="admin" /> } />
                  <Route path="donor/*" element={<ProtectedComponent Component={DonorRoutes}  requiredRole="donor"/>} /> 
                  <Route path="requestor/*" element={<ProtectedComponent Component={RequestorRoutes} requiredRole="Requestor"/>} />  
                  <Route path="/session-timeout"  element={<ProtectedComponent Component={SessionTimeout} />}  />
                  <Route path="profile-management/*" element={<ProtectedComponent Component={ProfileManagementRoutes}/>} />  
                  <Route path="policies/*"  element={<ProtectedComponent Component={PoliciesRoute}  />}  />
                  <Route path="help" element={<ProtectedComponent Component={Help}/>} />  
                  <Route path="payment/*" element={<PaymentRoutes/>} />  
                  <Route path="/*" element={<AuthRoutes setIsLoggedIn={setIsLoggedIn} />} /> 
                </Routes> 
                
            {/* </BrowserRouter> */}
          </FilterInfo.Provider>
      </GlobalInfo.Provider>
    </>
);

}

export default AppRoutes;